const CLOUDFRONT_BASE = 'https://d2stmgbubsmbr5.cloudfront.net';
const CACHE_TTL_MS = 60 * 60 * 1000;
const memCache = new Map();
export async function getTranslations(lang, onError) {
    const mem = memCache.get(lang);
    if (mem && Date.now() - mem.fetchedAt < CACHE_TTL_MS) {
        return mem.strings;
    }
    try {
        const raw = sessionStorage.getItem(`aidkit_i18n_${lang}`);
        if (raw) {
            const entry = JSON.parse(raw);
            if (Date.now() - entry.fetchedAt < CACHE_TTL_MS) {
                memCache.set(lang, entry);
                return entry.strings;
            }
        }
    }
    catch { }
    try {
        const response = await fetch(`${CLOUDFRONT_BASE}/latest/${lang}.json`);
        if (!response.ok) {
            const error = new Error(`HTTP ${response.status}`);
            onError?.(error);
            return null;
        }
        const strings = await response.json();
        const entry = { strings, fetchedAt: Date.now() };
        memCache.set(lang, entry);
        try {
            sessionStorage.setItem(`aidkit_i18n_${lang}`, JSON.stringify(entry));
        }
        catch { }
        return strings;
    }
    catch (e) {
        const error = e instanceof Error ? e : new Error(String(e));
        onError?.(error);
        return null;
    }
}
